import type { PropsWithChildren } from "react"

import { AdminSidebar } from "@/components/admin-sidebar"
import { AppContent } from "@/components/app-content"
import { AppShell } from "@/components/app-shell"
import { AppSidebarHeader } from "@/components/app-sidebar-header"
import type { BreadcrumbItem } from "@/types"

export default function AdminSidebarLayout({
  children,
  breadcrumbs = [],
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[]
}>) {
  return (
    <AppShell variant="sidebar">
      <AdminSidebar />
      {/* overflow-x-clip (not -hidden): hidden makes this element the scroll
          container for position:sticky descendants (RecordForm's Save bar),
          which breaks their pinning since the document is what scrolls. */}
      <AppContent variant="sidebar" className="overflow-x-clip">
        <AppSidebarHeader breadcrumbs={breadcrumbs} />
        {children}
      </AppContent>
    </AppShell>
  )
}
